import {
  BalanceSignupStatusContextFields,
  BalanceValidationStatus,
} from 'src/components/selfService/common/Balance/balanceSignup.types';

export enum ValidationStepState {
  PENDING = 'PENDING',
  IN_REVIEW = 'IN_REVIEW',
  REJECTED = 'REJECTED',
  APPROVED_WITH_NET_TERMS = 'APPROVED_WITH_NET_TERMS',
  APPROVED_WITHOUT_NET_TERMS = 'APPROVED_WITHOUT_NET_TERMS',
}

export interface ValidationStepFooterConfig {
  primaryText: string;
  isPrimaryDisabled: boolean;
  shouldOpenOnboardingUrl: boolean;
}

export interface ValidationStepStateComponentProps {
  onboardingUrl: string | null;
  creditLimit: number | null;
}

type GetValidationStepStateParams = Pick<
  BalanceSignupStatusContextFields,
  'validationStatus' | 'creditLimit'
>;

export function getValidationStepState({
  validationStatus,
  creditLimit,
}: GetValidationStepStateParams): ValidationStepState {
  switch (validationStatus) {
    case BalanceValidationStatus.IN_REVIEW:
      return ValidationStepState.IN_REVIEW;
    case BalanceValidationStatus.REJECTED:
      return ValidationStepState.REJECTED;
    case BalanceValidationStatus.APPROVED:
      return creditLimit === null
        ? ValidationStepState.APPROVED_WITHOUT_NET_TERMS
        : ValidationStepState.APPROVED_WITH_NET_TERMS;
    default:
      return ValidationStepState.PENDING;
  }
}

const PRIMARY_DISABLED_STATES: ValidationStepState[] = [
  ValidationStepState.IN_REVIEW,
  ValidationStepState.REJECTED,
];

export function getValidationStepFooterConfig(
  state: ValidationStepState
): ValidationStepFooterConfig {
  return {
    primaryText:
      state === ValidationStepState.PENDING ? 'Continue to Balance' : 'Next',
    isPrimaryDisabled: PRIMARY_DISABLED_STATES.includes(state),
    shouldOpenOnboardingUrl: state === ValidationStepState.PENDING,
  };
}
